import React from 'react';
import type { ViewId } from '../types/navigation';
const LOGO_SRC = 'https://cdn.magicpatterns.com/uploads/ao2DrHXUU5TPkmLZkMQLjL/Namnlos_(Instagram-inlagg_(45)).png';
const LINKS: {
  view: ViewId;
  label: string;
}[] = [{
  view: 'hem',
  label: 'Hem'
}, {
  view: 'meny',
  label: 'Meny'
}, {
  view: 'vin',
  label: 'Lite Vin'
}, {
  view: 'forbestall',
  label: 'Förbeställ'
}];
type Props = {
  view: ViewId;
  onNavigate: (view: ViewId) => void;
};
export function SiteNav({
  view,
  onNavigate
}: Props) {
  return <header className="sticky top-0 z-50 w-full bg-cream/95 backdrop-blur border-b border-ink/10" data-id="element-95" data-mp="2wmg9xvzje8jz">
      <div className="max-w-6xl mx-auto px-6 h-16 md:h-20 flex items-center justify-between gap-6" data-id="element-96" data-mp="2rpg2bgn1gxqr">
        <button type="button" onClick={() => onNavigate('hem')} className="shrink-0" aria-label="Till startsidan" data-id="element-97" data-mp="2mqd8ytgf8fym">
          <img src={LOGO_SRC} alt="Lilla Verket" className="h-7 md:h-9 w-auto" draggable={false} data-id="element-98" data-mp="ky6wj17o7ejd" />
        </button>

        <nav aria-label="Huvudmeny" className="flex-1 min-w-0" data-id="element-99" data-mp="91p0d560lj0n">
          <ul className="flex items-center justify-end gap-5 sm:gap-7 overflow-x-auto" data-id="element-100" data-mp="dzgr3vuxaz39">
            {LINKS.map(link => {
            const isActive = view === link.view;
            return <li key={link.view} data-id="element-101" data-mp="41ar5jsog311">
                  <button type="button" onClick={() => onNavigate(link.view)} aria-current={isActive ? 'page' : undefined} className={`block whitespace-nowrap pb-0.5 border-b font-sans text-[10px] md:text-[11px] tracking-[0.2em] uppercase transition-colors duration-200 ${isActive ? 'border-ink text-ink' : 'border-transparent text-ink/55 hover:text-ink'}`} data-id="element-102" data-mp="42cbyfzhw3vy">
                    {link.label}
                  </button>
                </li>;
          })}
          </ul>
        </nav>

        <button type="button" onClick={() => onNavigate('boka')} className="hidden sm:inline-flex shrink-0 items-center px-5 py-2.5 rounded-full bg-ink text-white font-sans text-[10px] tracking-[0.2em] uppercase hover:bg-ink/85 transition-colors duration-200" data-id="element-103" data-mp="1p9ke2et8y9h6">
          Boka bord
        </button>
      </div>
    </header>;
}